import isNil from "./isNil.js";
/**
 * Returns an object with all nullable values removed.
 *
 * @example
 * ```ts
 * const compacted = compactObject({ a: 1, b: "b", c: null, d: undefined });
 * // {a: 1, b: "b"}
 * ```
 */
export default function compactObject(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, value]) => !isNil(value)));
}
//# sourceMappingURL=compactObject.js.map